export default __webpack_public_path__ + "static/media/RossSantaDance.b8890d5d.gif";